import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetReportsTableData: '[GetReportsTableData] Action',
  SetReportsData: '[SetReportsData] Action',
  GetReportsTranslateData: '[GetReportsTranslateData] Action',

  GetReportDetailTableData: '[GetReportDetailTableData] Action',
  SetReportDetailData: '[SetReportDetailData] Action',
  GetReportDetailTranslateData: '[GetReportDetailTranslateData] Action',
}

const initialReportsState: IReportsState = {
  reportsColumnList: [],
  reportsColumnValues: [],
  reportsDefinitions: [],
  reportsColumnNames: [],
  reportsDataTypes: [],
  reportsDe: [],
  reportsEn: [],
  reportssOptions: [],

  reportDetailColumnList: [],
  reportDetailColumnValues: [],
  reportDetailDefinitions: [],
  reportDetailColumnNames: [],
  reportDetailDataTypes: [],
  reportDetailDe: [],
  reportDetailEn: [],
  reportDetailOptions: []
}

export interface IReportsState {
  reportsColumnValues: [],
  reportsColumnList: [],
  reportsDefinitions: []
  reportsColumnNames: [],
  reportsDataTypes: [],
  reportsDe: [],
  reportsEn: [],
  reportssOptions: [],

  reportDetailColumnList: [],
  reportDetailColumnValues: [],
  reportDetailDefinitions: [],
  reportDetailColumnNames: [],
  reportDetailDataTypes: [],
  reportDetailDe: [],
  reportDetailEn: [],
  reportDetailOptions: []
}

export const reducer = persistReducer(
  { storage, key: 'portal-Reports', whitelist:  [ ] },
  (state: IReportsState = initialReportsState, action: any) => {
    switch (action.type) {
      case actionTypes.GetReportsTableData: {
        const reportsColumnValues = JSON.parse(action.payload.data.reportdefinitionHeaders);
        let headers = JSON.parse(action.payload.data.headers);
        let reportsDefinitions = JSON.parse(action.payload.data.definitions);
        let reportsColumnNames = action.payload.data.columnNames;
        let reportsDataTypes = action.payload.data.dataTypes;
        let reportsColumnList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          reportsColumnList.push(newElement[0]);
        });
        return { ...state, reportsColumnList, reportsColumnValues, reportsDefinitions, reportsDataTypes , reportsColumnNames};
      }

      case actionTypes.GetReportDetailTableData: {
        const reportDetailColumnValues = JSON.parse(action.payload.data.reportdefinitionDetails);
        let headers = JSON.parse(action.payload.data.headers);
        let reportDetailDefinitions = JSON.parse(action.payload.data.definitions);
        let reportDetailColumnNames = action.payload.data.columnNames;
        let reportDetailDataTypes = action.payload.data.dataTypes;
        let reportDetailColumnList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          reportDetailColumnList.push(newElement[0]);
        });
        return { ...state, reportDetailColumnList, reportDetailColumnValues, reportDetailDefinitions, reportDetailDataTypes , reportDetailColumnNames};
      }
    
      case actionTypes.SetReportsData: {
        const reportsColumnValues = action.payload.data;
        return { ...state, reportsColumnValues };
      }

      case actionTypes.SetReportDetailData: {
        const reportDetailColumnValues = action.payload.data;
        return { ...state, reportDetailColumnValues };
      }

      case actionTypes.GetReportsTranslateData: {
        const reportsDe = JSON.parse(action.payload.data.de);
        const reportsEn = JSON.parse(action.payload.data.en);
        return { ...state, reportsDe, reportsEn };
      }

      case actionTypes.GetReportDetailTranslateData: {
        const reportDetailDe = JSON.parse(action.payload.data.de);
        const reportDetailEn = JSON.parse(action.payload.data.en);
        return { ...state, reportDetailDe, reportDetailEn };
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getTranslateData: (data: any) => ({ type: actionTypes.GetReportsTranslateData, payload: { data } }),
  getReportsTableData: (data: any) => ({ type: actionTypes.GetReportsTableData, payload: { data } }),
  setReportsData: (data: any) => ({ type: actionTypes.SetReportsData, payload: { data } }),
  getDetailTranslateData: (data: any) => ({ type: actionTypes.GetReportDetailTranslateData, payload: { data } }),
  getReportDetailTableData: (data: any) => ({ type: actionTypes.GetReportDetailTableData, payload: { data } }),
  setReportDetailData: (data: any) => ({ type: actionTypes.SetReportDetailData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
